import MEDIA_QUERIES from './media-queries';

const matchMediaQueryMaxWidth = max => {
	const query = `(max-width: ${max}px)`;
	return window.matchMedia( query ).matches;
};

const matchMediaQueryRange = ( min, max ) => {
	const query = `(min-width: ${min}px) and (max-width: ${max}px)`;
	return window.matchMedia( query ).matches;
};

const matchMediaQueryMin = min => {
	const query = `(min-width: ${min}px)`;
	return window.matchMedia( query ).matches;
};

const device = () => {
	if ( matchMediaQueryMaxWidth( MEDIA_QUERIES.MOBILE_PORTRAIT ) ) {
		return 'MOBILE_PORTRAIT';
	}
	if (
		matchMediaQueryRange(
			MEDIA_QUERIES.MOBILE_PORTRAIT,
			MEDIA_QUERIES.MOBILE_LANDSCAPE,
		)
	) {
		return 'MOBILE_LANDSCAPE';
	}
	if (
		matchMediaQueryRange( MEDIA_QUERIES.MOBILE_LANDSCAPE, MEDIA_QUERIES.TABLET )
	) {
		return 'TABLET';
	}
	if ( matchMediaQueryRange( MEDIA_QUERIES.TABLET, MEDIA_QUERIES.DESKTOP ) ) {
		return 'DESKTOP';
	}
	if ( matchMediaQueryMin( MEDIA_QUERIES.DESKTOP ) ) {
		return 'DESKTOP_LARGE';
	}
};
export default device;
